/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type BulkVersionUpdateAIToolPathParams = NonNullable<
  operations['bulkVersionUpdateAITool']['parameters']['path']
>;

export type BulkVersionUpdateAIToolRequestBody = OperationRequestBodyContent<operations['bulkVersionUpdateAITool']>;

export interface Input extends BulkVersionUpdateAIToolPathParams {
  apiVersion?: string;
  body: BulkVersionUpdateAIToolRequestBody;
}

export async function bulkVersionUpdateAITool(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/ai-configs/ai-tools/{toolKey}/bulk-version-update', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
